<template>
    <va-edit-layout>
        <FinancialOrder-form
            :id="id"
            :title="title"
            :item="item"
        ></FinancialOrder-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
